import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Entity, Video, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps, EntityStack, useLang, VideoMeta } from '@shapeable/ui';

const cls = classNames('video-card');

// -------- Types -------->

export type VideoCardProps = Omit<EntityCardProps, 'entity'> & { 
  entity: Video;
  linkEntireCard?: boolean;
};

export const VideoCardDefaultProps: Omit<VideoCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  descriptionMaxLines: 4,

};


// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ImageStyles = breakpoints({
  base: css`
    
  `,
});

const ConnectedPeopleStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Meta: styled(VideoMeta)`${ConnectedPeopleStyles}`,
};

export const VideoCard: Shapeable.FC<VideoCardProps> = (props) => {
  const { className, children, entity, linkEntireCard, ...rest } = props;
  
  const t = useLang();

  const { authors = [] } = entity;

  return (
    <My.Container 
      {...rest}
      showExternalLink={false}
      entity={entity}
      useLink={true}
      meta={
        <My.Meta 
          entity={entity}
          
        />
      }
      className={cls.name(className)}>
      {children}
    </My.Container>
  )
};


VideoCard.cls = cls;
